import { RoundedBox } from '@react-three/drei'
import { useVerandaSelector } from '../../../../..'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import { useMarquee } from '../../../../../hooks/state/useMarquee'

interface Props {
  fabricWidth: number
  position: [number, number, number]
  rotation: [number, number, number]
}

export const MarqueeFabric = ({
  fabricWidth,
  position,
  rotation,
}: Props): JSX.Element => {
  const { roofLogWidth, isQubus, eavesWidth, verandaTyp } = useMeasures()
  const { color } = useRoof()
  const { maqrueeAttributes, marqueeTyp } = useMarquee()
  const shadingMode = useVerandaSelector((state) => state.scene.shadingMode)
  const roofLenth = roofLogWidth - (isQubus ? 0.07 : 0)
  const fabric = {
    width: fabricWidth - 0.05,
    height: maqrueeAttributes.farbric.depth,
    length: shadingMode
      ? roofLenth -
        (marqueeTyp.hasUnderRoof ? eavesWidth + verandaTyp.log.depth : 0)
      : roofLenth / 2,
  }

  const bar = {
    width: fabricWidth - 0.0125,
    height: fabric.height + 0.005,
    length: 0.15,
  }

  const marqueeFabricLength = fabric.length - bar.length / 2

  return (
    <group position={position} rotation={rotation}>
      <RoundedBox
        args={[fabric.height, fabric.width, fabric.length - bar.length / 2]}
        position={[0, 0, -(fabric.length - bar.height) / 2]}
        radius={0.00001}
        castShadow
        receiveShadow
      >
        <CachedMeshPhysicalMaterial
          color={marqueeTyp.color}
          roughness={0.3}
          metalness={0.4}
          envMapIntensity={0.7}
        />
      </RoundedBox>

      <RoundedBox
        args={[bar.height, bar.width, bar.length]}
        position={[0, 0, -marqueeFabricLength + 0.015]}
        radius={bar.height * 0.01}
        castShadow
        receiveShadow
      >
        <CachedMeshPhysicalMaterial color={color} />
      </RoundedBox>
    </group>
  )
}
